module.exports = __webpack_public_path__ + "img/GH-syoukai-top-logo.8833644c.png";